module.exports = __webpack_public_path__ + "img/female.f1cbfb70.png";